import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TaskService, Task, TaskPage } from '../../services/task.service';
import { CondominiumService } from '../../services/condominium.service';

@Component({
    selector: 'app-tasks-all',
    templateUrl: './tasks-all.component.html',
    styleUrls: ['./tasks-all.component.sass'],
    standalone: false
})
export class TasksAllComponent implements OnInit {
  tasks: Task[] = [];
  isLoading = true;
  currentPage = 0;
  pageSize = 10;
  totalElements = 0;
  condominiumId: number | null = null;

  constructor(
    private taskService: TaskService,
    private condominiumService: CondominiumService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    let routeIdParam = this.route.parent?.snapshot.paramMap.get('id');
    if (routeIdParam) {
      this.condominiumId = Number.parseInt(routeIdParam);
      this.loadTasks();
    } else {
      this.router.navigate(['/condominiums']);
    }
  }

  async loadTasks(): Promise<void> {
    if (!this.condominiumId) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.taskService.getTasks(this.condominiumId, this.currentPage, this.pageSize).subscribe({
      next: (response: TaskPage) => {
        this.tasks = response._embedded?.taskResponseDTOList || [];
        this.totalElements = response.page.totalElements;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading tasks:', error);
        this.isLoading = false;
      }
    });
  }

  onPageChange(event: any): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadTasks();
  }

  navigateToTask(id: number): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/task`, id]);
    }
  }

  navigateToCreateTask(): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/task/create`]);
    } else {
      this.router.navigate(['/condominiums']);
    }
  }
}
